const STORAGE_KEY = '__impersonationUID__';

export function setImpersonationUID(uid) {
  if (uid) {
    window.__impersonateUID = uid;
    localStorage.setItem(STORAGE_KEY, uid);
  } else {
    clearImpersonationUID();
  }
}

export function clearImpersonationUID() {
  delete window.__impersonateUID;
  localStorage.removeItem(STORAGE_KEY);
}

export function getImpersonationUID() {
  if (window.__impersonateUID) return window.__impersonateUID;
  
  const saved = localStorage.getItem(STORAGE_KEY);
  if (saved) {
    window.__impersonateUID = saved;
    return saved;
  }
  
  return null;
}

getImpersonationUID();
